<app-back-to-system-overview relativeUrl="../../"></app-back-to-system-overview>

<div class="sp-container">
  <sh-card>
    <app-spare-parts-tabs
      [countDisplay]="ticketCountDisplay$ | async"
      (tabChange)="selectedTab.set($event)"
      [selectedTab]="selectedTab()"
    ></app-spare-parts-tabs>

    <app-spare-parts-filter
      [filter]="ticketFilter()"
      (filterChange)="onFilterChange()"
      [dateRange]="dateRange$ | async"
      (dateRangeChange)="onDateRangeChange($event)"
      [disableSearch]="disableFilters()"
      [disableModal]="disableFilters()"
    ></app-spare-parts-filter>

    <api-call-gate
      [apiCall]="[
        ticketsService.getSparePartsOverview,
        chartDataService.getHighestConsumedParts,
        chartDataService.getAmountConsumedParts,
      ]"
      loadingLabel="{{ 'spareParts.loadingTickets' | translate }}"
    >
      <ng-template #lastSuccessfulData>
        @let allServiceTickets = allServiceTickets$ | async;
        @let filteredTickets = filteredTickets$ | async;
        @let allServiceParts = allServiceParts$ | async;
        @let filteredParts = filteredParts$ | async;

        @switch (selectedTab()) {
          @case (TAB_SERVICE_TICKETS) {
            <app-service-tickets
              [tickets]="filteredTickets"
              (sortChange)="onTicketsSortChange($event)"
            ></app-service-tickets>

            @if (SRC_DATE_RANGE === filterSourceTickets) {
              @if (allServiceTickets?.length === 0) {
                @if (isFirstDateRange()) {
                  <!-- 1st time entering the screen -->
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: {
                        $implicit: {
                          title: 'spareParts.emptyState.expandTimeTickets',
                          header: 'spareParts.emptyState.noDataPastYear',
                          klass: 'empty-state-tickets',
                        },
                      }
                    "
                  ></ng-container>
                } @else if (is3YearPeriod()) {
                  <!-- There's no ticket in 3 years period -->
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: {
                        $implicit: {
                          title: 'spareParts.emptyState.noTicketsDevice',
                          header: 'spareParts.emptyState.noDataAvailable',
                          klass: 'empty-state-tickets',
                        },
                      }
                    "
                  ></ng-container>
                } @else {
                  <!-- maybe, there's tickets inside 3 years period -->
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: {
                        $implicit: {
                          title: 'spareParts.emptyState.expandTimeTickets',
                          header: 'spareParts.emptyState.noDataMatches',
                          klass: 'empty-state-tickets',
                        },
                      }
                    "
                  ></ng-container>
                }
              } @else if (filteredTickets?.length === 0) {
                <!-- maybe, there's tickets inside 3 years period -->
                <ng-container
                  *ngTemplateOutlet="
                    noDataTemplate;
                    context: {
                      $implicit: {
                        title: 'spareParts.emptyState.expandTimeTickets',
                        header: 'spareParts.emptyState.noDataMatches',
                        klass: 'empty-state-tickets',
                      },
                    }
                  "
                ></ng-container>
              }
            } @else if (
              SRC_INPUT_MODAL === filterSourceTickets &&
              filteredTickets?.length === 0
            ) {
              <ng-container
                *ngTemplateOutlet="
                  noResultsFound;
                  context: { $implicit: { klass: 'empty-state-tickets' } }
                "
              ></ng-container>
            }
          }
          @case (TAB_SERVICE_PARTS) {
            <app-service-parts
              [expanded]="true"
              [parts]="filteredParts"
              (sortChange)="onPartsSortChange($event)"
            ></app-service-parts>
            @if (SRC_DATE_RANGE === filterSourceParts) {
              @if (allServiceParts?.length === 0) {
                @if (isFirstDateRange()) {
                  <!-- 1st time entering the screen -->
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: {
                        $implicit: {
                          title: 'spareParts.emptyState.expandTimeRecords',
                          header: 'spareParts.emptyState.noDataPastYear',
                          klass: 'empty-state-parts',
                        },
                      }
                    "
                  ></ng-container>
                } @else if (is3YearPeriod()) {
                  <!-- There's no ticket in 3 years period -->
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: {
                        $implicit: {
                          title: 'spareParts.emptyState.noRecordsDevice',
                          header: 'spareParts.emptyState.noDataAvailable',
                          klass: 'empty-state-parts',
                        },
                      }
                    "
                  ></ng-container>
                } @else {
                  <!-- maybe, there's tickets inside 3 years period -->
                  <ng-container
                    *ngTemplateOutlet="
                      noDataTemplate;
                      context: {
                        $implicit: {
                          title: 'spareParts.emptyState.expandTimeRecords',
                          header: 'spareParts.emptyState.noDataMatches',
                          klass: 'empty-state-parts',
                        },
                      }
                    "
                  ></ng-container>
                }
              } @else if (filteredParts?.length === 0) {
                <!-- maybe, there's tickets inside 3 years period -->
                <ng-container
                  *ngTemplateOutlet="
                    noDataTemplate;
                    context: {
                      $implicit: {
                        title: 'spareParts.emptyState.expandTimeRecords',
                        header: 'spareParts.emptyState.noDataMatches',
                        klass: 'empty-state-parts',
                      },
                    }
                  "
                ></ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="widgets"></ng-container>
              }
            } @else if (
              SRC_INPUT_MODAL === filterSourceParts &&
              filteredParts?.length === 0
            ) {
              <ng-container
                *ngTemplateOutlet="
                  noResultsFound;
                  context: { $implicit: { klass: 'empty-state-parts' } }
                "
              ></ng-container>
            } @else {
              <ng-container *ngTemplateOutlet="widgets"></ng-container>
            }

            <ng-container *ngTemplateOutlet="graphs"></ng-container>
          }
        }
      </ng-template>
    </api-call-gate>
  </sh-card>
</div>

<ng-template #noDataTemplate let-data>
  <ng-container
    *ngTemplateOutlet="
      emptyState;
      context: {
        $implicit: {
          title: data.title,
          header: data.header,
          klass: data.klass,
          icon: 'list-viewmode',
        },
      }
    "
  ></ng-container>
</ng-template>

<ng-template #noResultsFound let-data>
  <ng-container
    *ngTemplateOutlet="
      emptyState;
      context: {
        $implicit: {
          title: 'spareParts.emptyState.refineSearch',
          header: 'spareParts.emptyState.noResults',
          klass: data.klass,
          icon: 'search',
        },
      }
    "
  ></ng-container>
</ng-template>

<ng-template #emptyState let-data>
  <div class="empty-state-container" [ngClass]="data.klass">
    <sh-empty-state
      icon="{{ data.icon }}"
      icon-color="secondary"
      label="{{ data.title | translate }}"
      header="{{ data.header | translate }}"
    >
    </sh-empty-state>
  </div>
</ng-template>

<ng-template #widgets>
  <app-widgets-service-parts
    [widgets]="widgetsValues$ | async"
  ></app-widgets-service-parts>
</ng-template>

<ng-template #graphs>
  <div id="graphs-container">
    @let highestPartsData = highestPartsData$ | async;
    @let amountConsumeData = amountConsumeData$ | async;
    @if (highestPartsData?.length > 0) {
      <sh-card
        ><app-highest-consumed-graph
          [values]="highestPartsData"
        ></app-highest-consumed-graph
      ></sh-card>
    } @else {
      <ng-container
        *ngTemplateOutlet="
          graphEmptyState;
          context: { $implicit: 'spareParts.HighestConsumed.title' }
        "
      ></ng-container>
    }
    @if (amountConsumeData?.length > 0) {
      <sh-card>
        <app-amount-consumed-graph
          [values]="amountConsumeData"
        ></app-amount-consumed-graph>
      </sh-card>
    } @else {
      <ng-container
        *ngTemplateOutlet="
          graphEmptyState;
          context: { $implicit: 'spareParts.AmountConsumed.title' }
        "
      ></ng-container>
    }
  </div>
</ng-template>

<ng-template #graphEmptyState let-title>
  <sh-card class="empty-state-graph">
    <header slot="header">
      <sh-text>{{ title | translate }}</sh-text>
      <sh-text color="secondary">
        {{ 'spareParts.subtitle.last12Months' | translate }}
      </sh-text>
    </header>
    <div class="graph-empty-state-body">
      <sh-text class="no-data-available">
        {{ 'spareParts.emptyState.noDataAvailable' | translate }}
      </sh-text>
    </div>
  </sh-card>
</ng-template>
